// Chart catalog. Each entry is a preset payload for an existing tool
// + eligibility, wrapped in a `resolve({ config })` function returning
// `{ ok: true, payload }` or `{ ok: false, reason }`.

import { allocationByMarketValue } from './entries/allocationByMarketValue'
import { allocationByNetCashFlow } from './entries/allocationByNetCashFlow'
import { mvVsNetAdditions } from './entries/mvVsNetAdditions'
import { performanceVsBenchmark } from './entries/performanceVsBenchmark'
import { riskVsReturn } from './entries/riskVsReturn'

export const CHART_CATALOG = Object.freeze([
  allocationByMarketValue,
  allocationByNetCashFlow,
  mvVsNetAdditions,
  performanceVsBenchmark,
  riskVsReturn
])

export const CHART_CATALOG_BY_ID = Object.freeze(
  CHART_CATALOG.reduce((acc, entry) => ({ ...acc, [entry.id]: entry }), {})
)

/**
 * Resolve a catalog entry against the live view config.
 * @returns {{ ok: true, entry, payload } | { ok: false, entry?, reason: string }}
 */
export function resolveCatalogEntry (id, ctx) {
  const entry = CHART_CATALOG_BY_ID[id]
  if (!entry) {
    return { ok: false, reason: 'Chart no longer available' }
  }
  const result = entry.resolve(ctx)
  if (result.ok) return { ok: true, entry, payload: result.payload }
  return { ok: false, entry, reason: result.reason }
}
